import React from 'react';
import { CurrentDossierProvider } from '@europrocurement/l2d-modules';
import { useParams } from 'react-router';
import DossierInfoValidation from './DossierInfoValidation';

const InfoValidation: React.FunctionComponent = function () {
    const { idDossier } = useParams();
    if (!idDossier) {
        console.log(`Dossier non trouvé paramètres url:  ${idDossier}`);
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }
    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <DossierInfoValidation />
        </CurrentDossierProvider>
    );
};

export default InfoValidation;
